export * from './heading.module';
export * from './heading.props';